import React from 'react';

const RowWidget = ({ children }) => {
    return (
        <div className="w-row">
            {children}
        </div>
    );
}

export default RowWidget;
